export enum IdVerificationDataModeEnum {
  liveness = 'liveness',
  auto = 'auto',
  expert = 'expert',
  certified = 'certified',
}
